import gsap from 'gsap';
import { ANIMATION_CONSTANTS } from '@/Scripts/constants';

export default {
  data () {
    return {
      opened: false
    };
  },
  methods: {
    animateOpen: function (callback) {
      // this._setHeightOnAnimate();
      this.opened = false;
      gsap.set(this.$refs.drawer, {
        height: 'auto',
        opacity: 1
      });
      gsap.from(this.$refs.drawer, ANIMATION_CONSTANTS.NORMAL, {
        css: {
          height: 0
        },
        ease: 'power2.easeOut',
        immediateRender: false,
        onComplete: () => {
          this.opened = true;
          this.$refs.drawer.style.height = 'auto';
          if (typeof callback !== 'undefined') {
            callback();
          }
        }
      });
      gsap.from(this.$refs.drawer, ANIMATION_CONSTANTS.SLOW, {
        css: {
          opacity: 0
        },
        ease: 'power2.easeIn'
      });
    },
    animateClose: function (callback) {
      // this._setHeightOnAnimate();
      this.opened = false;
      gsap.to(this.$refs.drawer, ANIMATION_CONSTANTS.NORMAL, {
        css: {
          height: 0
        },
        ease: 'expo.easeOut',
        onComplete: () => {
          if (typeof callback !== 'undefined') {
            callback();
            // this._resetHeightOnAnimate();
          }
        }
      });
    },
    updateHeight: function () {
      gsap.set(this.$refs.drawer, {
        height: 'auto',
        opacity: 1
      });
    },
    animateIntro: function (index) {
      gsap.from(this.$refs.header, 0.33, {
        autoAlpha: 0,
        scaleY: 0.75,
        translateY: -20,
        ease: 'power2.easeIn',
        delay: 0.1 * index
      });
    }
  }
};
